import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import startOfToday from 'date-fns/startOfToday';

import { Month } from '../types';
import getCurrentYearMonthAndDate from './getCurrentYearMonthAndDate';
import getDateMonthAndYear from './getDateMonthAndYear';

function getFirstPossibleDateMonthAndYear({
  earliestDate,
  minDate,
  maxDate,
}: {
  earliestDate?: Date | null;
  minDate?: Date | null;
  maxDate?: Date | null;
}): Month {
  const today = startOfToday();

  if (earliestDate) {
    return getDateMonthAndYear(earliestDate);
  } else if (minDate && isAfter(minDate, today)) {
    return getDateMonthAndYear(minDate);
  } else if (maxDate && isBefore(maxDate, today)) {
    return getDateMonthAndYear(maxDate);
  }

  return getCurrentYearMonthAndDate();
}

export default getFirstPossibleDateMonthAndYear;
